import { render, staticRenderFns } from "./GuideQuestion.vue?vue&type=template&id=4ebea169&scoped=true"
import script from "./GuideQuestion.vue?vue&type=script&lang=js"
export * from "./GuideQuestion.vue?vue&type=script&lang=js"
import style0 from "./GuideQuestion.vue?vue&type=style&index=0&id=4ebea169&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebea169",
  null
  
)

export default component.exports